interface Props {
  isStockAvailable: boolean;
}

const StockStatus = ({ isStockAvailable }: Props) => {
  return (
    <>
      {isStockAvailable ? (
        <span className="badge text-bg-success">มีสินค้า</span>
      ) : (
        <span className="badge text-bg-danger">สินค้าหมด</span>
      )}
    </>
  );
};

export default StockStatus;
